<div class="scroll">
  <div class="content">

    <div class="hero container">
      <div class="column is-8 is-offset-2">
        <div class="container has-text-centered">
          <img src="assets/caddie_logo.png" alt="CADDIE logo" title="CADDIE logo" />
          <h2 class="subtitle is-3"> A Coronavirus Explorer </h2>
        </div>
        <div class="content">
          <br>
          <h2 class="subtitle">Gene/Protein Data</h2>

          <h2>Drug Data</h2>

          <h2 class="subtitle">Interaction Data</h2>

          <h2 class="subtitle">Interaction Data</h2>

        </div>
      </div>
    </div>
  </div>
</div>



